import axios from 'axios'
import { BUSCAR_CIDADES } from '../types'
import { URL } from '../../util/ambienteActions';
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil';
import { carregarCacheCidades } from '../../util/offlineStorage';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

function buscarCidadesOffline(nome, empresaId) {
  if (!empresaId) return [];
  const cidades = carregarCacheCidades(empresaId);
  if (!cidades) return [];

  const termo = nome.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  return cidades.filter(c => {
    const nomeCidade = (c.nome || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    return nomeCidade.includes(termo);
  });
}

export default function buscarCidadesPorNome (nome) {
  const url = `${URL}/public/cidades/nome/${nome.replace(/[.*+?^${};%()|[\]\\]/g, '')}`;
  return (dispatch, getState) => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => dispatch({ type: BUSCAR_CIDADES, payload: response }))
    .catch(erro => {
      if (!navigator.onLine || !erro.response) {
        const empresaId = getState().empresaSelecionada && getState().empresaSelecionada.id;
        const cidades = buscarCidadesOffline(nome, empresaId);
        return dispatch({ type: BUSCAR_CIDADES, payload: { data: cidades } });
      }
      throw erro;
    });
}
